import { axiosRequest } from "../../configs/axios.config";

export class ApplicantSectionsService {
getApplicantSections(success, error) {
    axiosRequest.get(`/organization_applicants_section`)
    .then(({ data }) => success(data))
    .catch(errorResp => error(errorResp))
  }

  update(id,values,success, error) {
    axiosRequest.put(`/organization_applicants_section/${id}`,{"organization_applicants_section": values})
    .then(({ data }) => success(data))
    .catch(errorResp => error(errorResp))
  }
}
